module.exports = __webpack_public_path__ + "static/tizzy-3afa91dab5edd56d6c55aeb04bca8aa3.gif";